import type { StatusKey } from '@bbpos/ui';
import type { PlatformRole } from '@bbpos/types';

export type { PlatformRole };

export interface PlatformUser {
  id: string;
  email: string;
  name: string;
  role: PlatformRole;
  phone?: string;
  is_active: boolean;
  last_login_at?: string;
  created_at: string;
  updated_at: string;
}

export interface PlatformUserListItem {
  id: string;
  email: string;
  name: string;
  role: PlatformRole;
  phone?: string;
  is_active: boolean;
  last_login_at?: string;
  created_at: string;
}

export interface PlatformUserListParams {
  search?: string;
  role?: PlatformRole;
  is_active?: boolean;
  page?: number;
  limit?: number;
}

interface ListMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface PlatformUserListResponse {
  data: PlatformUserListItem[];
  meta: ListMeta;
}

export interface CreatePlatformUserPayload {
  email: string;
  name: string;
  role: PlatformRole;
  phone?: string;
  password: string;
}

export interface UpdatePlatformUserPayload {
  name?: string;
  role?: PlatformRole;
  phone?: string;
}

export const PLATFORM_ROLE_LEVELS: Record<PlatformRole, number> = {
  SUPER_ADMIN: 100,
  ADMIN: 80,
  MODERATOR: 60,
};

export const PLATFORM_ROLE_BADGE_VARIANT: Record<PlatformRole, StatusKey> = {
  SUPER_ADMIN: 'danger',
  ADMIN: 'active',
  MODERATOR: 'pending',
};

export const PLATFORM_ROLE_LABEL: Record<PlatformRole, string> = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Admin',
  MODERATOR: 'Moderator',
};

export const PLATFORM_ROLE_DESCRIPTION: Record<PlatformRole, string> = {
  SUPER_ADMIN: 'Full platform control — manage platform staff, tenants, and global configuration',
  ADMIN: 'Operational platform access — tenant administration and support tooling',
  MODERATOR: 'Read-only access to platform data for triage and moderation',
};
